module.exports = __webpack_public_path__ + "static/media/Greece.e518e14d.png";